import { MobileBaseObject } from "./mobile-base-object";

export interface IUserCheckIn extends MobileBaseObject {
  usermappingId: string;
  checkIn: Date;
  checkOut: Date;
}

export class UserCheckIn extends MobileBaseObject implements IUserCheckIn {

  public usermappingId: string;
  public checkIn: Date;
  public checkOut: Date;

  public get isCheckedIn(): boolean {
    return this.checkOut === undefined || this.checkOut === null;
  }

  public constructor(userCheckIn: Partial<IUserCheckIn> = null) {
    super();

    if (userCheckIn != null) {
      this.usermappingId = userCheckIn.usermappingId;
      if (userCheckIn.checkIn !== undefined && userCheckIn.checkIn !== null)
        this.checkIn = new Date(userCheckIn.checkIn);
      else
        this.checkIn = null;

      if (userCheckIn.checkOut !== undefined && userCheckIn.checkOut !== null)
        this.checkOut = new Date(userCheckIn.checkOut);
      else
        this.checkOut = null;

      this.id = userCheckIn.id;
      this.createdAt = new Date(userCheckIn.createdAt);
      this.updatedAt = new Date(userCheckIn.updatedAt);
    }
  }

}
